import Splide from '@splidejs/splide';
import YTPlayer from '../../../scripts/components/YTPlayer';

export const initReviewsSlider = () => {
  new Splide('[data-index-reviews-slider]', {
    type: 'loop',
    role: 'group',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    autoplay: true,
    classes: {
      pagination: 'index-reviews__slider-pagination',
      page: 'index-reviews__slider-pagination-btn',
    },
  }).mount();

  YTPlayer.init();
};
